import React from 'react';
import { FEDRAL_DATASETS_AGOL_GROUP } from '../../constants/map';

import { CalciteBtn } from '../Calcite';

const IntroSection = () => {
    return (
        <div className="container text-calcite-text-2 my-12 m:flex items-center">
            <div className="m:w-3/5 mb-6">
                <h3 className="text-4xl">Simplified Access to Critical Data</h3>

                <p className="mt-6">
                    Solving the nation&#39;s increasingly complex challenges
                    requires a diverse community of data-driven experts. GIS and
                    spatial data have proved foundational to analyzing,
                    understanding, and communicating issues that range from
                    epidemics to transportation infrastructure and the expanding
                    climate crisis. U.S. government-developed data are often
                    foundational input to tackling these challenges.
                </p>

                <p className="mt-6">
                    Working with the Federal Geographic Data Committee (
                    <a
                        href="https://www.fgdc.gov/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        FGDC
                    </a>
                    ) and federal agencies, Esri is improving access to a core
                    set of dozens of high-priority, high-demand national
                    geospatial data layers included in the National Geospatial
                    Data Asset Portfolio (
                    <a
                        href="https://www.fgdc.gov/initiatives/ngda-management-plan"
                        target="_blank"
                        rel="noreferrer"
                    >
                        NGDA
                    </a>
                    ).
                </p>
            </div>

            <div className="m:w-2/5 text-center">
                <CalciteBtn
                    lable="Access the Collection"
                    onClick={() => {
                        window.open(FEDRAL_DATASETS_AGOL_GROUP, '_blank');
                    }}
                />
            </div>
        </div>
    );
};

export default IntroSection;
